import { withDestroyViewerReset } from 'app/api/reset-reducer-helpers';
import { PAGE_LOAD } from 'app/api/redux-jigsaw/jigsaw-events';
import { createReducer } from 'app/api/redux-util/general-helpers';
import { isEmpty } from 'app/utils/objects';

/**
 * Maintain at least one object, array length should equal number of pages
 * Selectors should filter out unloaded items
 *
 * Keeps old page data around until a new event comes in because we don't
 * have a great way to tell what events go with what views
 */
const pageLoadReducer = createReducer([], {
  [PAGE_LOAD]: (state, action) => {
    const newState = [...state];
    const oldData = state[action.data.documentIndex];
    if (!oldData || isEmpty(oldData)) {
      newState[action.data.documentIndex] = action.data;
    } else {
      newState[action.data.documentIndex] = {
        ...action.data,
        // Temporary workaround K8BK-86, where we get bad values from Jigsaw
        // due to a bug in the loading event handling. Putting this in so
        // we can meet our live date, but it needs to be fixed for real within
        // Jigsaw.
        boundingRectWidth: Math.max(
          action.data.boundingRectWidth,
          oldData.boundingRectWidth
        ),
        boundingRectHeight: Math.max(
          action.data.boundingRectHeight,
          oldData.boundingRectHeight
        ),
      };
    }
    // This is writeable! Who knew?
    newState.length = action.data.dps ? 2 : 1;

    return newState;
  },
});

export default withDestroyViewerReset(pageLoadReducer);
